import React, { useState, useRef } from 'react';
import { IoChevronForwardOutline } from 'react-icons/io5';
import { BsArrowRightShort } from 'react-icons/bs';
import { Button } from "../../Atoms";
import { useNavigate } from 'react-router-dom';

import serviceimg1 from "../../Assets/services/serviceimg1.webp"
import serviceimg2 from "../../Assets/services/serviceimg2.webp"
import serviceimg3 from "../../Assets/services/serviceimg3.webp"
import serviceimg4 from "../../Assets/services/serviceimg4.webp"
import serviceimg5 from "../../Assets/services/serviceimg5.webp"

const SERVICES = [
  {
    title: 'Site Services',
    desc: 'We start with a clear picture of your site so every decision downstream is grounded in real feasibility data.',
    image:
      serviceimg1,
    items: [
     'Site evaluation & consultation',
      'Help navigating process of grid connection enhancement',      
    ],
  },
  {
    title: 'Installation',
    desc: 'End-to-end installation handled by our team, from civil works through to a fully commissioned, ready-to-use charger.',
    image:
      serviceimg2,
    items: [
      'Ground works',
      'Site electrical works',
      'Charger installation',
      'Charger / App commissioning',
      'Use training',
    ],
  },
  {
    title: 'Extended Warranty',
    desc: 'Get more years out of your existing hardware with genuine spare parts and extended coverage options.',
    image:
      serviceimg5,
    items: ['Spare parts', 'Extended warranty'],
  },
  {
    title: 'Warranty Operations',
    desc: 'Ongoing support that keeps chargers running, with remote diagnostics catching most issues before they affect uptime.',
    image:
      serviceimg3,
    items: [
      'Remote diagnostics',
      'On site corrective maintenance',
      'Software upgrades',
      'App support',
    ],
  },
  
  {
    title: 'End-of-life',
    desc: 'When it is time to retire or refresh a unit, we make renewal and responsible recycling straightforward.',
    image:
      serviceimg4,
    items: ['Renewals', 'Recycling & upcycling'],
  },
];

function AccordionItem({ service, isOpen, onToggle }) {
  const contentRef = useRef(null);
  const { title, desc, image, items } = service;
  const navigate = useNavigate();
  return (
    <div className="border-b border-gray-200">
      <button
        type="button"
        onClick={onToggle}
        aria-expanded={isOpen}
        className="w-full flex items-center justify-between py-4 sm:py-5 lg:py-6 text-left"
      >
        <span className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-semibold font-gilroy text-gray-900 pr-4">
          {title}
        </span>
        <span
          className={`relative flex-shrink-0 w-8 h-8 sm:w-9 sm:h-9 rounded-full flex items-center justify-center transition-colors duration-300 ${
            isOpen ? 'bg-green' : 'bg-gray-100'
          }`}
        >
          <span
            className={`absolute w-3.5 h-[1.5px] ${
              isOpen ? 'bg-white' : 'bg-gray-900'
            }`}
          />
          <span
            className={`absolute w-[1.5px] h-3.5 origin-center transition-transform duration-300 ${
              isOpen ? 'scale-y-0 bg-white' : 'scale-y-100 bg-gray-900'
            }`}
          />
        </span>
      </button>

      <div
        ref={contentRef}
        style={{
          height: isOpen ? contentRef.current?.scrollHeight ?? 'auto' : 0,
        }}
        className="overflow-hidden transition-[height] duration-300 ease-in-out"
      >
        <div className="pb-8 sm:pb-9 lg:pb-10 flex flex-col lg:flex-row gap-6 sm:gap-7 lg:gap-10 items-start py-4">
          {/* Image */}
          <div className="w-full sm:max-w-md sm:mx-auto lg:max-w-none lg:mx-0 lg:basis-2/5 shrink-0">
            <div className="rounded-2xl overflow-hidden bg-grey ">
              <img
                loading="lazy"
                src={image}
                alt={title}
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Detail */}
          <div className="w-full lg:basis-3/5">
            <p className="font-poppins font-light  text-base sm:text-lg lg:text-2xl mb-4">
              {desc}
            </p>

            <ul className="font-poppins text-gray-700 space-y-2 mb-6">
              {items.map((item) => (
                <li key={item} className="flex justify-items-start items-center gap-2 text-base sm:text-base lg:text-lg">
                  <span className="w-1.5 h-1.5 rounded-full bg-green shrink-0 d-flex justify-content-center" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>

            {/* <Button
              title="Get in touch"
              onClick={() => navigate("/get-in-touch#contact-us")}
            /> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default function OurServicesAccordion() {
  const [openIndex, setOpenIndex] = useState(0);

  const handleToggle = (index) => {
    setOpenIndex((current) => (current === index ? -1 : index));
  };

  return (
    <section className="blade-margin-top-xs">
      <div className="max-w-xl md:max-w-3xl lg:max-w-7xl mx-auto w-11/12 px-2 md:px-4">
        {/* <h2 className="text-center font-gilroy mb-3 h3">Our services</h2>
        <p className="font-poppins font-light text-center text-base sm:text-lg lg:text-2xl max-w-3xl mx-auto mb-6 md:mb-8 lg:mb-10 text-gray-600">
          Everything you need across the lifecycle of your charging
          infrastructure — from site evaluation through end-of-life.
        </p> */}

        <div className="border-t border-gray-200">
          {SERVICES.map((service, index) => (
            <AccordionItem
              key={service.title}
              service={service}
              isOpen={openIndex === index}
              onToggle={() => handleToggle(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}